export const loQueSeaAFloat = (stringOrNumber: any) => {
  if (typeof (stringOrNumber) == 'number') {
    return stringOrNumber;
  }
  return parseFloat(stringOrNumber);
};
